import XeroSignInHtml from './xero.sign-in.html';

export const XeroSignInComponent : ng.IComponentOptions = {
  controller : 'XeroSignInCtrl',
  templateUrl: XeroSignInHtml
};
